export default __webpack_public_path__ + "static/media/pluses6.ddfd6f03.png";